<template>
  <div>
    <small class="m-0 text-uppercase fw-bold" href="http://axiosdev.com.au">Powered By Axios</small>
    <small class="version m-0">Version {{ appVersion }}</small>
  </div>
</template>
<script>
import store from "../store";

export default {
  name: "Version",
  computed: {
    appVersion() {
      return store.getters.appVersion;
    }
  },
 async beforeCreate() {
    store.dispatch("loadAppVersion");
  }
};
</script>
